import ApiServer from '@/utils/api/ApiServer.js'
import { rateSheetLineFromServerToBuilder } from '@/components/activity/rate-sheet/RateSheet'
import RateSheet from '@/model/RateSheet.js'

export default {
  async fetchRateSheet (_, rateSheetId) {
    const path = `rateSheets/${rateSheetId}`
    const response = await ApiServer.get(path)
    if (response.data.rateSheetLines?.length > 0) {
      response.data.rateSheetLines = response.data.rateSheetLines.map(rateSheetLineFromServerToBuilder)
    }
    return RateSheet.fromServerResponse(response.data)
  }
}
